@if (activeQuestion) {
  <div [formGroup]="activeQuestion" class="file-upload-settings__container">
    <empathy-required-setting [activeQuestion]="activeQuestion"></empathy-required-setting>

    <div class="file-upload-settings__input-containers">
      <div class="editor-question-form__input">
        <span class="label"> Minimum files required </span>
        @if (activeQuestion.value.requiredInd) {
          <span class="sublabel">When question is required, the min value is 1 by default</span>
        }
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="minLength" [min]="activeQuestion.value.requiredInd ? 1 : 0" />
        </mat-form-field>
      </div>

      <div class="editor-question-form__input">
        <span class="label"> Maximum files allowed </span>
        <span class="sublabel">When the value is 0 the setting does not apply</span>
        <mat-form-field appearance="outline">
          <input matInput type="number" formControlName="maxLength" />
        </mat-form-field>
      </div>
    </div>
  </div>
}
